var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-backtop',{attrs:{"right":5,"bottom":20}}),_c('Contact'),_c('Header'),(_vm.isDetail)?_c('NewsDetail'):_c('NewsList'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }